import ShippingAddressUtil from './shippingAddressUtil.js';
import {OrderManager, OrderService, ErrorMessageCookieService, AdrService, CheckoutApi, CartService,
    SalesEventService, ExternalPaymentService, ExternalPaymentStatusEnum, ProcessorCode, AgreementService} from '@nuskin/ns-shop';
import {events, StickyHeaderStack, nuskin} from '@nuskin/ns-util';
import ScrollUtil from './scrollUtil.js';
import PromoCodeOffers from './promoCodeOffers.js';
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {UserService} from '@nuskin/ns-account';

/**
 *
 * OrderUtil
 *
 * @namespace OrderUtil
 */
const OrderUtil = function() {
    'use strict';
    const CREATE_SUCCESS = 'Successful';
    const CREATE_FAIL = 'Failed';

    const DISCONTINUED_EXCEPTION = 'ProductDiscontinuedException';

    const SHOPEXCEPTION = ['ShopException', 'MemberException'];
    const CARTEXCEPTION = ['OrderException', DISCONTINUED_EXCEPTION];
    const SHIPEXCEPTION = ['ShipException'];
    // Need to show Promo Code Exceptions in side bar if config is turned on;
    let PAYMENTEXCEPTION = null; // set later
    const PROMOCODEEXCEPTION = ['PromoCodeException'];
    const REVIEWEXCEPTION = [];

    let $scope;
    let $rootScope;
    let $timeout;
    let $q;
    let $http;
    let nsUtil;
    let simulatePromiseDependencies;
    let orderFound;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {

        /**
         * Initializes Orders
         * @memberof OrderUtil
         * @example
         * OrderUtil.initOrders(scope, location, timeout, q, http, nsUtilService, simulatePromDependencies)
         */
        initOrders: function(scope, rootScope, timeout, q, http, nsUtilService, simulatePromDependencies) {
            $scope = scope;
            $rootScope = rootScope;
            $timeout = timeout;
            $q = q;
            $http = http;
            orderFound = false;
            nsUtil = nsUtilService;
            simulatePromiseDependencies = simulatePromDependencies;

            PAYMENTEXCEPTION = ['PaymentException'];

            // Load orderPreferences
            $scope.orderPreferences = OrderManager.getOrderPreferences();
            $scope.order = OrderManager.getOrder();

            // No orders in local storage or only completed orders then
            if (!$scope.order) {
                OrderManager.setupOrders($scope.tdc.adrSignUpRequirementsNotMet, $scope.adrType.isImmediate);
                $scope.order = OrderManager.getOrder();
            } else {
                // We have a stored order.  Read it from local storage
                checkInstallments();

                // Check to see if the order is different than the cart
                // Plus Check to see if we initialized an external payment launch
                // If externalPaymentReturns an error then don't clear the orderlist
                if ($scope.order.cartTimestamp != CartService.getCartProperty('timestamp') ||
                    ($scope.order.externalPayment && ExternalPaymentService.getUrlPaymentStatus() === ExternalPaymentStatusEnum.SUCCESS) ||
                    doesOrderNeedToBeSplit()) {
                    // The cart has changed or we have done the initial payment.
                    // Remove the orders from storage and build new orders
                    OrderManager.clearOrders();
                    OrderManager.setupOrders($scope.tdc.adrSignUpRequirementsNotMet, $scope.adrType.isImmediate);
                    $scope.order = OrderManager.getOrder();
                } else {
                    // If shipping available methods is empty then we don't have a fully simulated order
                    if (!nsUtil.isEmpty($scope.order.shippingAvailableMethods)) {
                        const shippingMethod = findShippingMethod($scope.order.shippingAvailableMethods, $scope.order.selectedShippingMethod);
                        if (shippingMethod !== null) {
                            $scope.order.selectedShippingMethod = shippingMethod;
                        }
                        orderFound = true;
                    }
                }
            }

            $scope.createOrderButtonText = $scope.tdc.placeMyOrderText;

            // Init public methods:
            $scope.createOrder = createOrder;
            $scope.simulateOrder = simulateOrder;
            $scope.simulateOrderWithElement = simulateOrderWithElement;
            $scope.orderTimeoutContinue = orderTimeoutContinue;
            $scope.refreshAndSimulate = refreshAndSimulate;
        },

        /**
         * Returns Order
         * @memberof OrderUtil
         * @example
         * OrderUtil.getOrderFound()
         */
        getOrderFound: function() {
            return orderFound;
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function findShippingMethod(shippingAvailableMethods, selectedShippingMethod) {
        let rv = selectedShippingMethod;

        if (nsUtil.isEmpty(rv) || (shippingAvailableMethods.findIndex((method) => method.Code === selectedShippingMethod.Code) < 0)) {
            // Get the first one
            if (shippingAvailableMethods.length > 0) {
                rv = shippingAvailableMethods[0];
            }
        }

        return rv;
    }

    /* function findIndex(shippingMethodCategory, shippingMethodCode) {
        let index = -1;

        if (shippingMethodCategory && shippingMethodCategory.methods) {
            index = nsUtil.find(shippingMethodCategory.methods, "code", shippingMethodCode);
        }

        return index;
    }

    function getSkus() {
        return CartService.getItemData().map(item => item.sku);
    }*/

    function setUserDownConvertStatus() {
        if ($scope.showDownConvertTncCheckbox && $scope.downConvertTncChecked) {
            const {id} = UserService.getUser();
            AgreementService.setDownConvertAgreedToTerms(id)
                .finally(() => console.log('Accepted down convert agreed to terms'));
        }
    }

    async function createOrder(element) {
        let processorCode;
        // If external payment was submitted and canceled.  Then the user clicked place order.
        const isCanceledExternalPayment = $scope.order.redirectUrl &&
            $scope.order.redirectUrl !== null &&
            $scope.order.redirectUrl !== undefined &&
            $scope.order.redirectUrl.length > 0 &&
            $scope.order.orderId &&
            $scope.order.orderId !== null &&
            $scope.order.orderId.length > 0;
        $scope.isBusy = true;
        $scope.sections.closeSections();
        AdrService.setAdrDraft($scope.adr);
        $scope.chosen.element = element;
        $scope.sections.clearErrors();
        for (let i = 0; i < $scope.order.availablePayments.length; i++) {
            if ($scope.order.availablePayments[i]['id'] == $scope.order.selectedPayment.paymentTypeId) {
                const selectedPayment = $scope.order.availablePayments[i];
                $scope.order.paymentClass = selectedPayment.paymentClass;
                $scope.order.paymentOfsId = selectedPayment.ofsId;

                events.publish(events.shop.TAG_METHOD_OF_PAYMENT, {
                    paymentName: selectedPayment.localizedName
                });

                processorCode = selectedPayment.processorCode;
                break;
            }
        }

        // If the user canceled external payment then an order has already been created.  We need to clear the order number and redirectUrl
        if (isCanceledExternalPayment) {
            // Todo maybe we should make the external payment status call to decide what to do with the status
            $scope.order.orderId = null;
            $scope.order.redirectUrl = null;
        }
        // Set Email Opt In flag for user if checked.
        if ($scope.emailOptIn) {
            $scope.updateUserEmailOptInStatus();
        }

        // Setting backdating...
        if ($scope.order.allowBackdating) {
            $scope.order.backdating = $scope.backdatingToggle;
        }

        // Copy in pick up name and number
        if (getCachedConfigField('enablePickUpPerson') && $scope.sections.shipmethod.showPickUpPerson) {
            $scope.order.pickupInfo = {
                pickupName: $scope.sections.shipmethod.pickUpName,
                pickupNumber: $scope.sections.shipmethod.pickUpNumber
            };
        }

        // Include the adr override number is we have an adr override.
        handleAdrOverridePoints();

        // Change State name back to SAP version -- Hack For Mexico City
        ShippingAddressUtil.mapStateToSAP($scope.order.selectedAddress);

        await SalesEventService.checkForWaits();

        try {
            if (await CartService.checkForMissingEventNames($scope.order)) {
                $scope.showEventMessageModal = true;
                $scope.apply();
                return;
            }
        } catch (err) {
            console.log('Error checking for event pricing on order', err);
        }

        setUserDownConvertStatus();
        try {
            if (!$scope.order.adr) {
                await OrderService.orderCreate();
            } else {
                if ($scope.adr.shipImmediate) {
                    await OrderService.adrShipImmediateCreate($scope.adr);
                } else {
                    // this is a little hack that we force regular ADR to not use external payment
                    // Todo: can we delete this
                    if (processorCode != ProcessorCode.DIRECTDEBIT) {
                        processorCode = '';
                    }
                    await OrderService.adrCreate($scope.adr);
                }
            }

            // Sync order with local storage
            OrderManager.saveOrders();
            // Also set the orderList on rootscope
            $rootScope.order = $scope.order;

            if (!isRequestInProgress()) {
                // Check successful http response for error messages
                loadSapErrors();
                $scope.chosen.isValid = true;
                $timeout(function() {
                    $scope.chosen.isValid = false;
                    if (!$scope.sections.general.error.hasErrorMessages() &&
                        !$scope.sections.hasErrorMessages() && !_orderHasErrors()) {
                        // $scope.isBusy = false;
                        updateOrderAndFinishUp(processorCode);
                    } else {
                        tagCreateStatus(CREATE_FAIL);
                        $scope.isBusy = false;
                    }
                }, 1500);
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.messages) {
                if ($scope.order.adr && $scope.adr.shipImmediate) {
                    processAdrShipImmediateError(err.response.data);
                }
            }
            loadSapErrors(err);

            // If this is for columbia we need to map the error reason to the COD. DE RTA. field.
            if ($scope.order.countryCode === 'CO' && err.response && err.response.data && err.response.data.SalesOrderResponse) {
                const messages = err.response.data.SalesOrderResponse.Messages;
                if (messages) {
                    const TYPE = 'INFO';
                    const CODE = '001(ZP)';
                    for (let i=0; i<messages.length; i++) {
                        if (messages[i].Type === TYPE && messages[i].Code === CODE) {
                            let message = messages[i].Message;
                            if (message) {
                                message = message.replace('CS: C RA: B RS: 12 Text: MOP GPAY:', '');
                                $scope.order.selectedPayment.codDeRta = message;
                            }
                            break;
                        }
                    }
                }
            }
            tagCreateStatus(CREATE_FAIL);
            // Sync order with local storage
            OrderManager.saveOrders();
            $scope.isBusy = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
    }

    async function refreshAndSimulate() {
        $scope.showEventMessageModal = false;
        $scope.apply();
        $scope.simulateOrder();
    }

    function simulateOrder() {
        // Only clear the errors if we are not returning from an external payment that has errors.
        if (!ExternalPaymentService.needToHandleExternalPayment()) {
            $scope.sections.clearErrors();
        }

        // Include the adr override number if we have an adr override.
        handleAdrOverridePoints();

        const deferred = $q.defer();
        // Chain the services together.
        $scope.isBusy = true;
        $q.all(simulatePromiseDependencies)
            .then(function() {
                let promise;
                // if adr do adr simulate
                if ($scope.order.adr && $scope.adr) {
                    if ($scope.adr.shipImmediate) {
                        promise = OrderService.adrShipImmediateSimulate($scope.adr);
                    } else {
                        promise = OrderService.adrSimulate($scope.adr);
                    }
                } else {
                    promise = OrderService.orderSimulate();
                }
                return promise;
            }, function() {
                // Error handling is already done for the payment and shipping calls
                $scope.isBusy = false;
                deferred.resolve(true); // meaning we have error
            })
            .then(function(response) {
                // if the selected shipping method was changed on the simulate call then the
                // order object needs to reflect that but we do not need another simulate.
                if (response.data) {
                    const orderResponse = response.data.SalesOrderResponse || response.data.AdrResponse;
                    const salesOrderDetail =
                        orderResponse.ADRDetail ?
                            orderResponse.ADRDetail.SalesOrderDetail :
                            orderResponse.SalesOrderDetail;
                    if (salesOrderDetail) {
                        if (
                            !$scope.order.selectedShippingMethod ||
                            $scope.order.selectedShippingMethod.Code != $scope.order.simulatedShippingMethod.Code
                        ) {
                            $scope.order.selectedShippingMethod = $scope.order.simulatedShippingMethod;
                        }
                    }
                }

                // sync order with local storage
                OrderManager.saveOrders();

                // check for ship methods
                if (!Array.isArray($scope.order.shippingAvailableMethods) ||
                    $scope.order.shippingAvailableMethods.length < 1) {
                    $scope.sections.shipmethod.error.addErrorMessage('error', {
                        text: $scope.tdc.shipMethodsError,
                        details: ''
                    });
                }

                // set selected shipping address type
                if ($scope.order.addressTypeList && $scope.order.addressTypeList.length > 1) {
                    $scope.sections.shipping.newAddress.addressType = $scope.order.addressTypeList[0].code;
                }

                if ($scope.order.simulateWithoutShipping) {
                    $scope.shippingAddresses = [];
                    $scope.shippingAddresses.push($scope.order.selectedAddress);
                    if ($scope.saveSAPAddresstoProfile && $scope.order.selectedAddress) {
                        $scope.saveSAPAddresstoProfile = false;
                        $scope.addSAPShippingAddress($scope.order.selectedAddress);
                    }
                    ShippingAddressUtil.setShippingComponentAddress($scope.order.selectedAddress);
                }

                // Apply the product / shipping discount code
                // If it was validated by the simulate
                $scope.continueBusy = false;
                // Sfter the simulate, we need to go thru each item so that we can update the description....
                loadSapErrors();
                // Check messages in order object for errors and add to error structure
                // Map error
                if (!$scope.continueBusy) {
                    $scope.isBusy = false;
                }

                PromoCodeOffers.setAppliedDiscounts();
                events.publish(events.shop.SIMULATE_COMPLETE);
                deferred.resolve();
            }, function(err) {
                // If simulate fails because of a bad promo code, clear out promo code from the order so it isn't saved in localStorage
                if (err.response && err.response.data && err.response.data.messages) {
                    const messages = err.response.data.messages;
                    const promo = messages.filter((message) => {
                        return message.code === 'promoCodeInvalid';
                    });

                    if (promo.length > 0) {
                        $scope.order.productDiscountCode = '';
                        $scope.order.shippingDiscountCode = '';
                    }
                }
                // Sync order with local storage
                OrderManager.saveOrders();
                // When simulate Call failed
                let errorMessage = '';
                try {
                    errorMessage = err.response.data.messages[0].type;
                } catch (e) {
                    console.log(e);
                }
                if ($scope.order.simulateWithoutShipping && errorMessage === 'ShipException') {
                    $scope.initShippingAddresses();
                    $scope.order.simulateWithoutShipping = false;
                    $scope.saveSAPAddresstoProfile = false;
                    // No addresses found.  Open the shipping section
                    $scope.sections.shipping.edit = true;
                    $scope.sections.shipping.pristine = false;
                    $scope.sections.cart.edit = false;
                    $scope.sections.cart.pristine = false;
                    $scope.contentLoaded = true;
                } else if (err && err.response && err.response.data && err.response.data.messages) {
                    loadSapErrors(err);
                } else {
                    if (err && err.response) {
                        $scope.sections.general.error.addErrorMessage('error', {
                            text: $scope.tdc.simulateFailedErrorMessage,
                            details: err.response.status + ' ' + err.response.statusText
                        });
                    } else {
                        $scope.sections.general.error.addErrorMessage('error', {
                            text: $scope.tdc.simulateFailedErrorMessage,
                            details: err
                        });
                    }
                    ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                    window.location = $scope.runConfig.landing;
                }
                if (!$scope.continueBusy) {
                    $scope.isBusy = false;
                }
                deferred.resolve(true); // meaning we have error
            });

        return deferred.promise;
    }


    function simulateOrderWithElement(element, callback) {
        // set the element first
        if (element) {
            $scope.chosen.element = element;
        }
        // call the simulateOrder, then put the checkmark
        $scope.simulateOrder().then(function(hasError) {
            if (!hasError) {
                $scope.chosen.isValid = true;
                $timeout(function() {
                    $scope.chosen.isValid = false;
                }, 1500);
            }
            if (typeof callback === 'function') {
                callback(!hasError);
            }
        });
    }

    function processAdrShipImmediateError(errorData) {
        // check to see if the response has a ADR number
        // This is a special case to handle the payment error in shipImmediate (SAP will handle that later)
        // It is really a hack until the full implementation
        if (Object.prototype.hasOwnProperty.call(errorData, 'AdrShipImmediateResponse')) {
            const adrResponse = errorData.AdrShipImmediateResponse.adrResponse;
            if (adrResponse && adrResponse.ADRDetail && adrResponse.ADRDetail.SalesOrderDetail) {
                const adrOverrideNumber = adrResponse.ADRDetail.SalesOrderDetail.OrderID;
                if (adrOverrideNumber) {
                    $scope.sections['payment'].error.addErrorMessage('info',
                        {text: $scope.tdc.adrShipImmediateFailedErrorMessage});
                    events.publish(events.shop.ORDER_PAYMENT_ERROR, {
                        level: 'warning',
                        message: $scope.tdc.adrShipImmediateFailedErrorMessage
                    });
                    // Big assumption for payment error (assuming there is only one error and one payment)
                    if (PAYMENTEXCEPTION.indexOf(errorData.messages[0].type) >= 0) {
                        $scope.order.errorResponseInfo = adrResponse.ADRDetail;
                    }
                    // ADR was successfully created despite errors; clear locally-cached ADR list
                    AdrService.clearLocalAdrList();
                }
            }
        }
    }

    function updateOrderAndFinishUp(processorCode) {
        // Consume waiting room ticket if there is one
        // TODO: add new waiting room stuff here
        finishUpHelper(processorCode);
    }

    // Called inside of finishUpHelper
    function goToConfirmationPage() {
        disableCreateOrderButton();
        $scope.isBusy = false;
        StickyHeaderStack.remove();
        CartService.goToCheckoutPage({route: 'orderconfirmation'});
    }

    // Finishes up the order and redirects to the confirmation page on success
    function finishUpHelper(processorCode) {
        if (processorCode && $scope.order.redirectUrl) {
            $scope.order.externalPayment = true;
            OrderManager.saveOrders();
            // $scope.isBusy = false;
            ExternalPaymentService.handleExternalPayment($scope.order, processorCode, $scope.sections, $scope.tdc);
        } else {
            // Order successfully completed
            $scope.order.completed = true;
            tagCreateStatus(CREATE_SUCCESS);
            OrderManager.saveOrders();
            // OPS let them know the order is done so the users site can be created
            if ($scope.runConfig.callbackUrl !== undefined && $scope.runConfig.callbackUrl !== null) {
                $http.get($scope.runConfig.callbackUrl + CartService.getOrderSkuQueryParams(false)).then(function() {
                    goToConfirmationPage();
                }, function() {
                    goToConfirmationPage();
                });
            } else {
                goToConfirmationPage();
            }
        }
    }

    function checkInstallments() {
        try {
            if (!$scope.adr && $scope.order.selectedPayment !== undefined && $scope.order.availablePayments !== undefined) {
                for (let i = 0; i < $scope.order.availablePayments.length; i++) {
                    if ($scope.order.availablePayments[i]['id'] == $scope.order.selectedPayment.paymentTypeId) {
                        $scope.order.selectedPayment.setInstallmentsAllowed($scope.order.availablePayments[i]['installmentsAllowed']);
                        $scope.order.selectedPayment.setAvailableInstallmentPeriods($scope.order.availablePayments[i]['installmentNumbers']);
                        if ($scope.order.availablePayments[i].minimumInstallmentAmount != null) {
                            if ($scope.order.availablePayments[i].minimumInstallmentAmount > $scope.order.orderTotals.grandTotal) {
                                $scope.order.selectedPayment.setInstallmentsAllowed(false);
                            }
                        }
                        break;
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * Returns true if $scope.order.messages contains error messages
     * @returns {*|boolean}
     * @private
     */
    function _orderHasErrors() {
        return $scope.order.messages && $scope.order.messages.length > 0 && $scope.order.messages.some((message) => message.level === 'ERROR');
    }

    // After a response from SAP is returned this method is called to read any messages from the order object and
    // populate the errorMessage object to be displayed by the display-errors directive
    function loadSapErrors(err) {
        let messages = $scope.order.messages;
        if (err && err.response && err.response.data && err.response.data.messages) {
            messages = err.response.data.messages;
            events.publish(events.shop.SHOP_ERROR, messages);
        }
        let i;
        let fatal = false;
        if (err && err.response && err.response.status) {
            if (err.response.status > 401 && err.response.status !== 503) {
                fatal = true;
                if (messages !== undefined && messages !== null) {
                    for (i = 0; i < messages.length; i++) {
                        if (messages[i].level === 'ERROR') {
                            $scope.sections.general.error.addErrorMessage(
                                'error', {text: messages[i].message, details: 'Class-' + messages[i].type + ' - Error: ' + messages[i].technicalMessage});
                            ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                            break;
                        }
                    }
                } else {
                    events.tag('fatalCheckoutError', {error: err});
                    $scope.sections.general.error.addErrorMessage(
                        'error', {text: err.response.data, details: 'Status: ' + err.response.status + ' ' + err.response.statusText});
                    ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                }
                tagCreateStatus(CREATE_FAIL);
                CartService.goToCheckoutPage({route: 'fatalError'});
            }
        }
        if (!fatal) {
            // Check for out of stock items then redirect to referer
            if ($scope.order.outOfStock && $scope.order.outOfStock.length > 0) {
                let message = '';
                if (messages && messages.length > 0 && messages[0].code == 'agelocMeOutOfStock') {
                    message = messages[0].message;
                } else {
                    for (i = 0; i < $scope.order.outOfStock.length; i++) {
                        const sku = $scope.order.outOfStock[i];
                        const title = $scope.order.outOfStockTitle[i];
                        if (title && title != 'null' && title != '') {
                            message += title + ' (' + sku + '); ';
                        } else {
                            message += sku + '; ';
                        }
                    }

                    if ($scope.tdc.outOfStockMessage) {
                        message += $scope.tdc.outOfStockMessage.toLowerCase();
                    }
                }
                $scope.sections.general.error.addErrorMessage('error', {text: message});
                ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                // The item is out of stock so we clear the shipping method from preferences in case it is out of stock for a pickup location
                $scope.order.selectedShippingMethod = null;
                // clear out of stock array so they aren't hanging around next time through if we get another error
                $scope.order.clearOutOfStock();
                // We need to clear the order to so we force a simulate next time we come into checkout
                OrderManager.removeOrder($scope.order);
                OrderManager.saveOrders();
                tagCreateStatus(CREATE_FAIL);
                window.location = $scope.runConfig.landing;
            } else if ($scope.shouldSelectPickupPoint() && (!$scope.order.pickupPoints || $scope.order.pickupPoints.length === 0)) {
                // Check if the user selected a pickup point ship method and no pickup points came back from sap
                $scope.sections.shipmethod.error.addErrorMessage('error', {text: $scope.tdc.pickupNoPointsFoundText});
            } else if (messages !== undefined && messages.length > 0) {
                // Messages should be prioritized, so we check the first message.  If it is an error then we look up the error mapping and display it.
                for (i = 0; i < messages.length; i++) {
                    if (messages[i].level === 'ERROR') {
                        // if the message is null replace the message with the technical message
                        if (messages[i].message === null || messages[i].message.indexOf('null') > -1) {
                            messages[i].message = messages[i].technicalMessage;
                        }
                        let section = 'general';
                        if (SHOPEXCEPTION.indexOf(messages[i].type) >= 0) {
                            // redirect to referring page and pass exception
                            $scope.sections.general.error.addErrorMessage(
                                'error', {text: messages[i].message, details: 'Class-' + messages[i].type + ' - Error: ' + messages[i].technicalMessage});
                            ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                            tagCreateStatus(CREATE_FAIL);
                            window.location = $scope.runConfig.landing;
                            break; // We are redirecting break out
                        } else if (SHIPEXCEPTION.indexOf(messages[i].type) >= 0) {
                            section = 'shipping';
                            $scope.sections.payment.edit = false;
                            events.publish(events.shop.ORDER_SHIPPING_ERROR, {level: 'error', message: messages[i].message});
                        } else if (PAYMENTEXCEPTION.indexOf(messages[i].type) >= 0) {
                            section = 'payment';

                            // Clear promocode field
                            if (messages[i].type === 'PromoCodeException') {
                                if ($scope.order.productDiscountCode && messages[i].technicalMessage.indexOf($scope.order.productDiscountCode) >= 0) {
                                    $scope.order.productDiscountCode = '';
                                    if (messages[i].code === 'promoNotValidForGroup') {
                                        // need to resimulate without promo code to get correct shipping price
                                        $scope.continueBusy = true;
                                        $scope.simulateOrder().then(function() {
                                            $scope.continueBusy = false;
                                            $scope.isBusy = false;
                                        });
                                    }
                                } else if ($scope.order.shippingDiscountCode && messages[i].technicalMessage.indexOf($scope.order.shippingDiscountCode) >= 0) {
                                    $scope.order.shippingDiscountCode = '';
                                }
                            } else {
                                events.publish(events.shop.ORDER_PAYMENT_ERROR, {level: 'error', message: messages[i].message});
                                $scope.sections.shipping.edit = false;
                            }
                        } else if (PROMOCODEEXCEPTION.indexOf(messages[i].type) >= 0) {
                            section = 'review';
                            $scope.sections.review.error.addErrorMessage(
                                'error', {text: messages[i].message, details: 'Class-' + messages[i].type + ' - Error: ' + messages[i].technicalMessage});
                        } else if (REVIEWEXCEPTION.indexOf(messages[i].type) >= 0) {
                            section = 'review';
                            // The promo code used to be part of REVIEW but
                            // was moved to PAYMENT. So this section is currently empty.
                            // TODO Remove this comment when a new "review " error type is
                            // available
                        } else if (CARTEXCEPTION.indexOf(messages[i].type) >= 0) {
                            // Special case: SKU is discontinued
                            const skuRegExp = /[0-9]{8}/;
                            if (DISCONTINUED_EXCEPTION === messages[i].type && skuRegExp.test(messages[i].message)) {
                                // get discontinued SKU from error message
                                const sku = messages[i].message.match(skuRegExp)[0];
                                // remove discontinued SKU from cart
                                CartService.removeItemBySku(sku);
                            }

                            $scope.sections.general.error.addErrorMessage(
                                'error', {text: messages[i].message, details: 'Class-' + messages[i].type + ' - Error: ' + messages[i].technicalMessage});
                            ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                            tagCreateStatus(CREATE_FAIL);
                            window.location = $scope.runConfig.landing;
                            break;
                        } else {
                            $scope.sections.general.error.addErrorMessage('error', {text: messages[i].message, details: 'Class-' + messages[i].type + ' - Error: ' + messages[i].technicalMessage});
                            ErrorMessageCookieService.setErrorMessages($scope.sections.general.error);
                        }

                        if (section === 'general') {
                            // Scroll to summary error
                            ScrollUtil.scrollToCheckoutErrorSummary();
                        }
                        break; // We found an error message so we don't need to loop through the rest
                    }
                }
            }
        }
    }

    function orderTimeoutContinue() {
        $scope.order.completed = true;
        OrderManager.saveOrders();
        CheckoutApi.cleanupOrder();
        if (OrderManager.getOrder()) {
            CartService.goToCheckoutPage();
        } else if ($scope.runConfig.cartUrl && $scope.runConfig.cartUrl.length > 0) {
            window.location = $scope.runConfig.cartUrl;
        } else {
            CartService.goToCartPage();
        }
    }

    function isRequestInProgress() {
        const messages = $scope.order.messages;
        let retVal = false;

        if (messages !== undefined && messages !== null) {
            messages.forEach((message) => {
                if (message.code === 'requestInProgress') {
                    retVal = true;
                    showRequestInProgressMessage($scope.tdc.orderCreateFailedErrorMessage);
                    if (!$scope.$$phase) {
                        $scope.$apply(); // to insure that the message will be seen.
                    }
                }
            });
        }

        return retVal;
    }

    function showRequestInProgressMessage(message) {
        $scope.timeoutMessage = message;
        document.querySelector('#requestInProgressOverlay').toggle();
        document.querySelector('.requestInProgress').style.display = 'flex';
    }

    function disableCreateOrderButton() {
        $scope.forceDisableOrderButton = true;
        $scope.isBusy = false;
    }

    function doesOrderNeedToBeSplit() {
        const orderHasAdr = CartService.getItemData({cartAdrItems: true}).length > 0;
        const orderHasNonAdr = CartService.getItemData({cartOrderItems: true}).length > 0;

        return !$scope.adrType.isImmediate && orderHasAdr && orderHasNonAdr;
    }

    // Retrieve points for ADR Override if points payment is enabled in this market
    function handleAdrOverridePoints() {
        if (AdrService.isAdrOverride() && nuskin.configuration.enableAdrOverridePointsRedemption) {
            AdrService.getAdrPoints().then((points) => $scope.adrPoints = points)
                .catch(console.error);
        }
    }

    function tagCreateStatus(status) {
        events.tag('checkoutPurchaseButtonClicked', {status: status});
    }

    return publicMethods;
}();

export default OrderUtil;
